import { useEffect, useState, useCallback } from "react";
import { createNoteApi, fetchNotesApi, fetchNotesGeneralApi, updateNoteApi, deleteNoteApi } from "../services/notesService";

export function useNotes({ workspaceId, token }) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ---------- GET ----------
  const fetchNotes = useCallback(async () => {
    if (!workspaceId) return;
    setLoading(true);
    setError("");

    try {
      const data = await fetchNotesApi({ workspaceId, token });
      setNotes(data);
    } catch (err) {
      console.error(err);
      setError("Failed to load notes.");
    } finally {
      setLoading(false);
    }
  }, [workspaceId, token]);

  // ---------- GET GENERAL ----------
  const fetchNotesGeneral = useCallback(async () => {
    if (!workspaceId) return;
    setLoading(true);
    setError("");

    try {
      const data = await fetchNotesGeneralApi({ workspaceId, token });
      setNotes(data);
    } catch (err) {
      console.error(err);
      setError("Failed to load notes.");
    } finally {
      setLoading(false);
    }
  }, [workspaceId, token]);

  // ---------- POST ----------
  const addNote = async (event) => {
    try {
      const newEvent = await createNoteApi({ token, event });
      setNotes((prev) => [...prev, newEvent]);
    } catch (err) {
      console.error(err);
      setError("Failed to create Note.");
    }
  };

  // ---------- UPDATE ----------
  const updateNote = async (id, updatedData) => {
    try {
      const updated = await updateNoteApi({ token, id, event: updatedData });
      setNotes((prev) => prev.map((e) => (e.id === id ? updated : e)));
    } catch (err) {
      console.error(err);
      setError("Failed to update Note.");
    }
  };

  // ---------- DELETE ----------
  const deleteNote = async (id) => {
    try {
      await deleteNoteApi({ token, id });
      setNotes((prev) => prev.filter((e) => e.id !== id));
    } catch (err) {
      console.error(err);
      setError("Failed to delete note.");
    }
  };

  return {
    notes,
    setNotes,
    loading,
    setLoading,
    error,
    setError,
    reload: fetchNotes,
    fetchNotes,
    fetchNotesGeneral,
    addNote,
    updateNote,
    deleteNote,
  };
}
